module.exports = __webpack_public_path__ + "10bc0622c831aac134b1003cd26c846a.svg";